<!-- Modal mode -->
<div *ngIf="mode === 'modal' && open" class="confirmation-modal">
    <div class="modal-content bulk-upload-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3>{{ title }}</h3>
        </div>
        <div class="modal-body bulk-upload-body">
            <p *ngIf="intro" class="bulk-upload-intro">{{ intro }}</p>
            <div class="bulk-upload-file-row">
                <button type="button" class="btn-action" (click)="fileInput.click()"
                        [disabled]="disabled || uploading">
                    <fa-icon [icon]="['fas', 'upload']"></fa-icon>
                    Choose File
                </button>
                <span class="bulk-upload-file-name">{{ selectedFile?.name || 'No file selected' }}</span>
            </div>
            <div class="bulk-upload-secondary-actions" *ngIf="showDownloadTemplate || showGuidelines">
                <button *ngIf="showDownloadTemplate" type="button" class="btn-action btn-compact"
                        (click)="downloadTemplate.emit()" [disabled]="disabled || uploading">
                    <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
                    Download Template
                </button>
                <button *ngIf="showGuidelines" type="button" class="btn-action btn-compact"
                        (click)="guidelinesClick.emit()" [disabled]="disabled || uploading">
                    <fa-icon [icon]="['fas', 'circle-exclamation']"></fa-icon>
                    Sample Guidelines
                </button>
            </div>
            <app-bulk-upload-supported-values
                    *ngIf="supportedFields?.length"
                    [title]="supportedTitle"
                    [fields]="supportedFields"
                    [tip]="supportedTip">
            </app-bulk-upload-supported-values>
        </div>
        <div class="button-row">
            <button type="button" class="btn-cancel" (click)="cancel.emit()" [disabled]="uploading">
                <fa-icon [icon]="['fas', 'square-xmark']"></fa-icon>
                Cancel
            </button>
            <button type="button" class="btn-action" (click)="onSubmit()"
                    [disabled]="!selectedFile || disabled || uploading">
                <fa-icon [icon]="['fas', 'upload']"></fa-icon>
                {{ uploading ? 'Uploading...' : 'Upload' }}
            </button>
        </div>
    </div>
</div>

<!-- Page mode (Vehicle Database style) -->
<div *ngIf="mode === 'page'" class="bulk-upload-page-actions btn-row">
    <a *ngIf="showDownloadTemplate" (click)="!disabled && downloadTemplate.emit()">
        <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin"></fa-icon>
        DOWNLOAD TEMPLATE
    </a>
    <a (click)="!disabled && !uploading && fileInput.click()">
        <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
        {{ uploading ? 'UPLOADING...' : 'UPLOAD FILE' }}
    </a>
    <a *ngIf="showGuidelines" (click)="!disabled && guidelinesClick.emit()">
        <fa-icon [icon]="['fas', 'circle-exclamation']" class="fa-thin"></fa-icon>
        SAMPLE GUIDELINES
    </a>
</div>

<!-- Inline mode (Hotlist / Blocklist style) -->
<span *ngIf="mode === 'inline'" class="bulk-upload-inline">
    <button type="button" class="btn-action" (click)="fileInput.click()"
            [disabled]="disabled || uploading"
            [title]="disabled ? 'You are not authorized to perform this action.' : title">
        <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
        Bulk Upload
    </button>
    <button
            *ngIf="showDownloadTemplate"
            type="button"
            class="btn-icon-action"
            (click)="downloadTemplate.emit()"
            [disabled]="disabled"
            title="Download Import Template">
        <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
    </button>
</span>

<input #fileInput type="file" [accept]="accept" (change)="onFileInputChange($event)" hidden/>
